module.exports = __webpack_public_path__ + "img/tintuc25.b6715125.png";